<header class="header">
  <h1>{{ title }}</h1>
  <ng-content></ng-content>
  <p class="subtitle" [innerHTML]="subtitle"></p>
</header>
